import { createTheme, responsiveFontSizes } from "@mui/material/styles";

// const theme = createTheme({
//   palette: {
//     primary: purple,
//   },
//   secondary: {
//     main: deepPurple[500],
//     contrastText: deepPurple[900],
//   },
// });

let theme = createTheme({
  palette: {
    primary: {
      light: "#000",
      main: "#000",
      dark: "#000",
    },
    secondary: {
      // main: "#6A4B80",
      main: "#FFF",
      dark: "#000",
    },
    third: {
      main: "#36164D",
      dark: "#000",
    },
    yellow: {
      main: "#FEFF02",
      dark: "#a3a300",
    },
    cherry: {
      main: "#ecb6b6",
    },
    green: {
      main: "#338ab641",
    },
  },
  typography: {
    h5: {
      fontWeight: 500,
      fontSize: 26,
      letterSpacing: 0.5,
    },
    fontFamily: ["Montserrat"].join(","),
    color: "white",
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiTab: {
      defaultProps: {
        disableRipple: true,
      },
    },
  },
  mixins: {
    toolbar: {
      minHeight: 48,
    },
  },
});

theme = responsiveFontSizes(theme);

theme = {
  ...theme,
  components: {
    MuiStepper: {
      styleOverrides: {
        root: {
          "& .MuiStepIcon-active": { color: "red" },
        },
        active: {},
        completed: {},
      },
    },

    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#000",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
        contained: {
          boxShadow: "none",
          "&:active": {
            boxShadow: "none",
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          marginLeft: theme.spacing(1),
        },
        indicator: {
          height: 3,
          borderTopLeftRadius: 3,
          borderTopRightRadius: 3,
          backgroundColor: theme.palette.common.white,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          margin: "0 16px",
          minWidth: 0,
          padding: 0,
          [theme.breakpoints.up("md")]: {
            padding: 0,
            minWidth: 0,
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: theme.spacing(1),
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          borderRadius: 4,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          backgroundColor: "rgb(255,255,255,0.15)",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            color: "#AD68A3",
          },
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: 14,
          fontWeight: theme.typography.fontWeightMedium,
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: "inherit",
          minWidth: "auto",
          marginRight: theme.spacing(2),
          "& svg": {
            fontSize: 20,
          },
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          width: 32,
          height: 32,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: "#fff5ff",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "#FFF",
        },
      },
    },
  },
};

export default theme;
